import { ActionButton, Card, Page } from "@eisox/design-system";
import { PlusIcon } from "@eisox/icons";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { floorApi } from "~/api";
import { AddFloorDrawer } from "~/features/floor";
import { buildingPageHead } from "~/helpers/document-title.helper";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/floors")({
  loader: async ({ context: { queryClient }, params: { buildingId } }) => {
    const floors = await queryClient.ensureQueryData(floorApi.queries.building(buildingId));
    if (floors.length > 0) {
      const firstFloor = floors[0];
      if (!firstFloor) return;
      return redirect({ to: "/buildings/$buildingId/floors/$floorId", params: { buildingId, floorId: firstFloor.id } });
    }
  },
  head: ({ match: { context }, params: { buildingId } }) => buildingPageHead(context.queryClient, buildingId, m.plan()),
  component: RouteComponent,
});

function RouteComponent() {
  const { buildingId } = Route.useParams();
  return (
    <Page.Root>
      <Page.Content className="m-10">
        <Card className="flex h-full w-full items-center justify-center">
          <AddFloorDrawer buildingId={buildingId}>
            <ActionButton>
              {m.add()} <PlusIcon />
            </ActionButton>
          </AddFloorDrawer>
        </Card>
      </Page.Content>
    </Page.Root>
  );
}
